import React from "react";
import { useTranslation } from "react-i18next";

const TrashIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="currentColor"
    aria-hidden="true"
  >
    <path d="M9.5 3a1 1 0 0 0-.9.55L8.1 5H5a1 1 0 1 0 0 2h14a1 1 0 1 0 0-2h-3.1l-.5-1.45A1 1 0 0 0 14.5 3h-5zM7 9v9.2c0 1 1 1.8 2.2 1.8h5.6c1.2 0 2.2-.8 2.2-1.8V9H7zm3 2.5a.75.75 0 0 1 1.5 0v6a.75.75 0 0 1-1.5 0v-6zm3.5 0a.75.75 0 0 1 1.5 0v6a.75.75 0 0 1-1.5 0v-6z" />
  </svg>
);

const PauseIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="14"
    height="14"
    viewBox="0 0 24 24"
    fill="currentColor"
    aria-hidden="true"
  >
    <rect x="6" y="5" width="4" height="14" rx="1" />
    <rect x="14" y="5" width="4" height="14" rx="1" />
  </svg>
);

const PlayIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="14"
    height="14"
    viewBox="0 0 24 24"
    fill="currentColor"
    aria-hidden="true"
  >
    <path d="M8 5.5v13l11-6.5L8 5.5z" />
  </svg>
);

const SendIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="20"
    height="20"
    viewBox="0 0 24 24"
    fill="currentColor"
    aria-hidden="true"
  >
    <path d="M2.01 21L23 12 2.01 3 2 10l15 2-15 2z" />
  </svg>
);

/**
 * Locked-mode voice recording bar: trash | pause + waveform + timer | send
 */
export default function VoiceRecordingBar({
  levels = [],
  durationLabel = "0:00",
  isPaused = false,
  disabled = false,
  onCancel,
  onTogglePause,
  onSend,
}) {
  const { t } = useTranslation();

  return (
    <div className="host-chat__voice-rec" role="group" aria-label={t("Recording")}>
      <button
        type="button"
        className="host-chat__voice-rec-trash"
        aria-label={t("Cancel")}
        disabled={disabled}
        onClick={onCancel}
      >
        <TrashIcon />
      </button>

      <div className={`host-chat__voice-rec-pill${isPaused ? " is-paused" : ""}`}>
        <button
          type="button"
          className="host-chat__voice-rec-pause"
          aria-label={isPaused ? t("Resume") : t("Pause")}
          disabled={disabled}
          onClick={onTogglePause}
        >
          {isPaused ? <PlayIcon /> : <PauseIcon />}
        </button>

        <div className="host-chat__voice-rec-wave" aria-hidden="true">
          {levels.map((level, index) => (
            <span
              key={index}
              className="host-chat__voice-rec-bar"
              style={{ height: `${Math.round(level * 100)}%` }}
            />
          ))}
        </div>

        <span className="host-chat__voice-rec-timer">{durationLabel}</span>
      </div>

      <button
        type="button"
        className="host-chat__voice-rec-send"
        aria-label={t("Send")}
        disabled={disabled}
        onClick={onSend}
      >
        <SendIcon />
      </button>
    </div>
  );
}
